import styled from 'styled-components';

export const StyledMedicalRecordNumberField = styled.div`
   width: 278px;
`;
StyledMedicalRecordNumberField.displayName = 'StyledMedicalRecordNumberField';
